<script>
export default {
  name: 'Progress',
  components: {},
  props: {
    questionText: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selectedOption: true,
      textareaContent: '',
    }
  },
  watch: {
    textareaContent() {
      this.$emit('changedTextArea', this.textareaContent)
    },
    selectedOption() {
      this.$emit('changedSelectionOpt', this.selectedOption)
    },
  },
  methods: {
    setOption(option) {
      this.selectedOption = option
    },
  },
}
</script>

<template>
  <div :class="$style.container">

    <h4>{{ questionText }}</h4>

    <div :class="$style.container__buttons">
      <BaseButton
        :seccondary="!selectedOption"
        @click="setOption(true)"
      >
        {{ $t('COMMON.YES') }}
      </BaseButton>

      <BaseButton
        :seccondary="selectedOption"
        @click="setOption(false)"
      >
        {{ $t('COMMON.NO') }}
      </BaseButton>
    </div>
    <div
      v-if="!selectedOption"
      :class="$style.textContainer"
    >
      <h5>
        Escríbenos tu mensaje:
      </h5>
      <BaseTextarea
        v-model="textareaContent"
        class-style="full"
        placeholder="Escríbenos aquí..."
        rows="2"
        name="textareaContent"
      />

    </div>

  </div>
</template>


<style scoped lang="scss" module>
@import '@design';
.container {
  display: flex;
  flex-flow: row wrap;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  padding: 1rem;
  background-color: $white;

  h4 {
    @extend %typography-medium;

    font-weight: 500;
    margin-bottom: 1rem;
  }

  h5 {
    @extend %typography-medium;

    margin: 1rem 0 1rem 0s;
    font-weight: 700;
    color: $medium-gray;
    text-align: left;
  }

  &__buttons {
    display: flex;
    flex-flow: row wrap;
    align-items: flex-start;
    justify-content: flex-start;
    width: 70%;

    @include responsive(phone) {
      width: 55%;
    }

    button {
      width: 6.5rem;
      height: 2.8rem;
      border-radius: 18px;
    }
  }
}

.textContainer {
  width: 100%;
  margin: 1rem 0 1rem 0;
}
</style>
